import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBullet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx={10} cy={9.787} r={3} />
  </svg>
);
export default SvgBullet;
